import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {
  constructor(private router: Router, private _AuthServiceLocal: AuthServiceLocal) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const userToken = localStorage.getItem('PWAToken')
    if (!userToken) {
      if (!route.queryParamMap.get('userId')) {
        this.router.navigate(['/auth/login'])
        return true;
      } else {
        return new Promise((resolve, reject) => {
          Promise.all([
            this._AuthServiceLocal.getCustomerDetails({ userId: route.queryParamMap.get('userId') }).then((res) => {
              if (res) {
                return false;
              } else {
                this.router.navigate(['/auth/login'])
                return true;
              }
            })
          ]).then(() => {
            resolve(true)
          })
        })
      }
    } else {
      return true;
    }
  }

}
